import { IReturn } from "../../api/return/ReturnsApi";

export default class Return {
  returnNumber?: string;
  resellerId?: number;
  status?: string;
  invoiceNumber?: string;
  requestDate?: string;
  creditNumber?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  comments?: string;
  resellerName?: string;
  warehouseLocation?: string;
  randmarSKU?: string;
  mpn?: string;
  title?: string;
  category?: string;
  unitWeight?: string;
  upc?: string;
  manufacturerName?: string;
  productType?: string;
  masterCarton?: number;
  skidQuantity?: number;
  serialNumber?: boolean;
  transparencyCode?: boolean;
  autoUpdate?: boolean;
  createdBy?: string;
  returnNumber1?: string;
  randmarSKU1?: string;
  quantity?: number;
  serialNumbers?: string;
  reasonForReturn?: string;

  constructor(source?: IReturn) {
    if (source) {
      this.returnNumber = source.ReturnNumber;
      this.resellerId = source.ResellerId;
      this.status = source.Status;
      this.invoiceNumber = source.InvoiceNumber;
      this.requestDate = source.RequestDate;
      this.creditNumber = source.CreditNumber;
      this.contactName = source.ContactName;
      this.contactPhone = source.ContactPhone;
      this.contactEmail = source.ContactEmail;
      this.comments = source.Comments;
      this.resellerName = source.ResellerName;
      this.warehouseLocation = source.WarehouseLocation;
      this.randmarSKU = source.RandmarSKU;
      this.mpn = source.MPN;
      this.title = source.Title;
      this.category = source.Category;
      this.unitWeight = source.UnitWeight;
      this.upc = source.UPC;
      this.manufacturerName = source.ManufacturerName;
      this.productType = source.ProductType;
      this.masterCarton = source.MasterCarton;
      this.skidQuantity = source.SkidQuantity;
      this.serialNumber = source.SerialNumber;
      this.transparencyCode = source.TransparencyCode;
      this.autoUpdate = source.AutoUpdate;
      this.createdBy = source.CreatedBy;
      this.returnNumber1 = source.ReturnNumber1;
      this.randmarSKU1 = source.RandmarSKU1;
      this.quantity = source.Quantity;
      this.serialNumbers = source.SerialNumbers;
      this.reasonForReturn = source.ReasonForReturn;
    }
  }

  public static convertFrom(source: IReturn): Return {
    return new Return(source);
  }
}
